import { createAction, props } from '@ngrx/store';

import { Cow } from '../../models/cow.model';

export const loadCowRequest = createAction(
  '[Cow] Load cow details',
  props<{ internationalCowId: string }>(),
);

export const loadCowSuccess = createAction('[Cow] Load cow succeeded', props<{ cow: Cow }>());
